import { render, staticRenderFns } from "./ArticleImportOverview.vue?vue&type=template&id=3dd9e182"
import script from "./ArticleImportOverview.vue?vue&type=script&lang=js"
export * from "./ArticleImportOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports